import { Component, ErrorHandler, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { absRoute, ROUTE_ORGANIZATION } from 'src/app/app-route.constants';
import { SessionService } from 'src/app/core/session/session.service';


@Component({
    selector: 'app-after-login',
    templateUrl: './after-login.component.html',
    styleUrls: ['./after-login.component.scss'],
    standalone: false
})
export class AfterLoginComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly sessionService = inject(SessionService);
  private readonly errorHandler = inject(ErrorHandler);


  ngOnInit() {
    this.sessionService.session$.subscribe(() => {
      void this.router.navigate([absRoute(ROUTE_ORGANIZATION)]).catch(error => this.errorHandler.handleError(error));
    });
  }

  reload() {
    window.location.reload();
  }
}
